import React, { useEffect, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { Button, Icon, Banner } from 'lb-components';

import _ from 'lodash';
import { CloseIcon } from '../../../assets/icons';
import verificationIcons from '../../../assets/icons/verification';

import classes from './Verification.module.scss';
import { Api, Toast, useTranslation } from 'lb-store';
import PaymentStatus from './Status';

const readFile = (file) => {
  return new Promise((resolve) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => resolve(fileReader.result);
  });
};
const texts = {
  1: {
    front: {
      title: 'ატვირთეთ წინა მხარე',
      label: 'პირადობის მოწმობის წინა მხარე',
    },
    back: {
      title: 'ატვირთეთ უკანა მხარე',
      label: 'პირადობის მოწმობის უკანა მხარე',
    },
    selfie: {
      title: 'ატვირთვა',
      label: 'მომხმარებლის ფოტო(სელფი) პირადობის მოწმობასთან ერთად',
    },
  },
  3: {
    front: {
      title: 'პასპორტის ფოტო',
      label: 'ატვირთეთ პასპორტის ფოტო',
    },
    selfie: {
      title: 'ატვირთვა',
      label: 'მომხმარებლის ფოტო(სელფი) პასპორტთან ერთად',
    },
  },
};

export const Verification = ({ onSuccess, referralId, ...props }) => {
  const [type, setType] = useState(1);
  const [index, setIndex] = useState(1);
  const [formData, setFormData] = useState({
    front: null,
    back: null,
    selfie: null,
  });
  const [loading, setLoading] = useState(null);
  const [loadKval, setLoadKval] = useState(0);
  const [error, setError] = useState({});
  const {t} = useTranslation();
  const [kvalifikaUrl,setKvalifikaUrl] = useState(null)
  const [status,setStatus]=useState(null)
  const uploadHandler = async (data) => {
    let response;
    if (!!referralId)
      response = await Api.User.ReferralVerification.Upload({
        referralId,
        ...data,
      });
    else response = await Api.User.Verification.Upload(data);

    if (!referralId && !response.status)
      Toast.show({ type: 'error', content: response.data?.desc });
    else {
      setFormData({ ...formData, [data.side]: data.file });
      setError(_.omit(error, [data.side]));
    }
    setLoading(null);
  };
  const submitHandler = () => {
    if (!!referralId) {
      const error = {};
      _.forIn(formData, (value, key) => {
        if (!value) error[key] = true;
      });
      if (!_.isEmpty(error)) setError(error);
      else {
        Api.User.ReferralVerification.Finish({ referralId }).then((res) => {
          if (res.status) {
            onSuccess();
          } else {
            Toast.show({ type: 'error', content: res.data?.desc });
          }
        });
      }
    } else {
      Api.User.Verification.Finish().then((res) => {
        if (res.status && res.data?.status === 1) {
          Api.User.Verification.CheckStatus().then((res) => {
            if (res.status && res.data?.status === 1) {
              onSuccess();
            }
          });
        } else
          Toast.show({
            type: 'error',
            content: t('დოკუმენტები ვერ აიტვირთა'),
          });
      });
    }
  };



  const renderHeader=()=>{
    return  (
      <div className={classes.buttonsContainer}>
        <Button
          className={type === 3 ? classes.inactive : null}
          onClick={() => {
            setType(1);
          }}
        >
          {t('მარტივი ვერიფიკაცია')}
        </Button> &nbsp;&nbsp;&nbsp;
        <Button
          className={type === 1 ? classes.inactive : null}
          onClick={() => {
            setType(3);

          }}
        >
          {t('სტანდარტული ვერიფიკაცია')}
        </Button>
      </div>
    )
  }

  const renderBullets=()=>{
    return  (
      <div className={classes.bulletsContainer}>
        <div>
          <input type="radio" id="bullet-1" name="type"  value="1"  checked={index===1}  onChange={e=>{
            setIndex(1);
            setFormData({
              front: null,
              back: null,
              selfie: null,
            });
            setError({});
            document.getElementById('form').reset();
          }}/>
            <label htmlFor="bullet-1">{t('პირადობის მოწმობა')}</label>
        </div>
        <div>
          <input type="radio" id="bullet-2" name="type"  checked={index===3} checked={index===3}  onChange={e=>{
            setIndex(3);
            setFormData({
              front: null,
              selfie: null,
            });
            setError({});
            document.getElementById('form').reset();
          }} />
            <label htmlFor="bullet-2">  {t('პასპორტი')}</label>
        </div>

      </div>
    )
  }


  const oldVerification = () =>{
    return (
      <React.Fragment>
        {
          renderBullets()
        }
        {/*<div className={classes.buttonsContainer}>
        <Button
          className={index === 3 ? classes.inactive : null}
          onClick={() => {
            setIndex(1);
            setFormData({
              front: null,
              back: null,
              selfie: null,
            });
            setError({});
            document.getElementById('form').reset();
          }}
        >
          {t('პირადობის მოწმობა')}
        </Button>
        <Button
          className={index === 1 ? classes.inactive : null}
          onClick={() => {
            setIndex(3);
            setFormData({
              front: null,
              selfie: null,
            });
            setError({});
            document.getElementById('form').reset();
          }}
        >
          {t('პასპორტი')}
        </Button>
      </div>*/}
        <Form
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            submitHandler();
          }}
          id={'form'}
          className={classes.form}
        >
          {_.map(formData, (value, key) => (
            <Row as={'section'} key={key} style={{ rowGap: '2rem' }}>
              <Col
                xs={12}
                md={5}
                className={error[key] ? classes.error : null}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div className={classes.imgContainer}>
                  {formData[key] && (
                    <Icon
                      Icon={CloseIcon}
                      type={'vec'}
                      style={{
                        height: '2rem',
                        width: '2rem',
                        backgroundColor: 'var(--bs-danger)',
                      }}
                      classname={classes.delete}
                      onClick={() => {
                        setFormData({ ...formData, [key]: null });
                        document.getElementById(key).value = '';
                      }}
                    />
                  )}

                  <Banner
                    aspectRatio={0.5662}
                    imgUrl={
                      formData[key]
                        ? formData[key]
                        : verificationIcons[index][key]
                    }
                    style={{ backgroundSize: formData[key] ? 'cover' : '70%' }}
                  />
                </div>
              </Col>
              <Col xs={12} md={{ span: 6, offset: 1 }}>
                <Form.Group className={classes.formGroup}>
                  <Form.Label className={classes.label}>
                    {t(texts[index][key].label)}
                  </Form.Label>
                  <label
                    className={classes.inputContainer}
                    style={{
                      backgroundColor:
                        loading === key
                          ? '#9c4c33'
                          : formData[key]
                            ? 'var(--bs-success)'
                            : null,
                      textAlign: loading === key ? 'center' : 'left',
                      color: loading === key ? '#ababab' : null,
                    }}
                  >
                    {loading === key
                      ? '...'
                      : formData[key]
                        ? t('ფოტოს შეცვლა')
                        : t(texts[index][key].title)}
                    <Form.Control
                      id={key}
                      name={key}
                      type={'file'}
                      accept={'image/x-png,image/gif,image/jpeg'}
                      disabled={loading === key}
                      onChange={(e) => {
                        setLoading(key);
                        readFile(e.target.files[0]).then((file) => {
                          uploadHandler({
                            type: index,
                            side: key,
                            file,
                          }).finally();
                        });
                      }}
                    />
                  </label>
                </Form.Group>
              </Col>
            </Row>
          ))}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '7rem',
            }}
          >
            <Button
              variant={'success'}
              type={'submit'}
              style={{ fontSize: '2rem', padding: '1.5rem 2.5rem' }}
            >
              {t('შენახვა')}
            </Button>
          </div>
        </Form>
      </React.Fragment>
    )
  }

  const newVerification=()=>{




    return  (
      <div className={classes.kualificaContainer}>

        {
          status === null && !kvalifikaUrl && <div className={classes.startKvalifika}>
              <p>{t('მარტივი ვერიფიკაციის დასაწყებად გთხოვთ დააჭიროთ ღილაკს ვერიფიკაციის დაწყება')}</p>
              {
                loadKval===1 ? <span className={classes.loaderKval}>{t('დაელოდეთ იტვირთება')} ...</span> :
                    (
                        <Button
                            className={type === 1 ? classes.inactive : null}
                            onClick={() => {
                              setLoadKval(1)
                              getKvalifikaUrl()
                            }}
                        >
                          {t('ვერიფიკაციის დაწყება')}
                        </Button>
                    )


              }
              {
                  loadKval===2 && <p className={classes.errorKval}>{t('შეცდომა ვერიფიკაციის დაწყებისას სცადეთ თავიდან')}</p>
              }

            </div>
        }

        {kvalifikaUrl && (
            <iframe
                allowFullScreen={true}
            src={kvalifikaUrl}
            allow="camera *"
            style={{
              width:"100%",
              height:"100%",
              overflowY:'scroll'
            }}/>
        )}

        {
          status ===2 && (
            <PaymentStatus status={"error"} msg={error}/>
          )

        }
        {
          status ===3 && (
            <PaymentStatus status={"success"} msg={error}/>
          )
        }

      </div>
    )
  }
  const getKvalifikaUrl = () =>{

    Api.User.Kvalifika().then(response=>{
      if (response?.status === false){
        setLoadKval(2)
        return
      }
      console.log(response)
      switch (response?.data?.data?.status){
        case 1: setKvalifikaUrl(response?.data?.data?.url); break;
        case 2: setStatus(2);   setError(response?.data?.data?.desc) ; break;
       case 3: setStatus(3);setError(response?.data?.data?.desc) ; break;
          default: break;
      }
      setLoadKval(0)
    })
  }
  useEffect(() => {

    //getKvalifikaUrl()
  }, []);

  return (
    <div className={classes.container}>
      {
        renderHeader()
      }

      {
         type===1? newVerification():oldVerification()
      }



    </div>
  );
};
